// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.success-screen {
  text-align: center;
  padding: 40px 20px;
}

.success-icon {
  width: 80px;
  height: 80px;
  margin: 0 auto 24px;
  background: linear-gradient(135deg, #4caf50 0%, #45a049 100%);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  animation: scaleIn 0.5s ease-out;
}

.success-icon svg {
  width: 48px;
  height: 48px;
  stroke: white;
}

@keyframes scaleIn {
  from {
    transform: scale(0);
    opacity: 0;
  }
  to {
    transform: scale(1);
    opacity: 1;
  }
}

.success-screen h2 {
  margin: 0 0 16px 0;
  color: #333;
  font-size: 32px;
  font-weight: 700;
}

.success-screen > p {
  color: #666;
  font-size: 16px;
  margin: 0 0 32px 0;
  line-height: 1.6;
}

.whatsapp-button {
  padding: 16px 48px;
  background: linear-gradient(135deg, #25d366 0%, #128c7e 100%);
  color: white;
  border: none;
  border-radius: 8px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  margin-bottom: 16px;
}

.whatsapp-button:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 20px rgba(37, 211, 102, 0.4);
}

.redirect-message {
  color: #999;
  font-size: 14px;
  margin: 0;
}

`, "",{"version":3,"sources":["webpack://./src/components/onboarding/SuccessScreen.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,6DAA6D;EAC7D,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gCAAgC;AAClC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;AACf;;AAEA;EACE;IACE,mBAAmB;IACnB,UAAU;EACZ;EACA;IACE,mBAAmB;IACnB,UAAU;EACZ;AACF;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,6DAA6D;EAC7D,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA;EACE,WAAW;EACX,eAAe;EACf,SAAS;AACX","sourcesContent":[".success-screen {\n  text-align: center;\n  padding: 40px 20px;\n}\n\n.success-icon {\n  width: 80px;\n  height: 80px;\n  margin: 0 auto 24px;\n  background: linear-gradient(135deg, #4caf50 0%, #45a049 100%);\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  animation: scaleIn 0.5s ease-out;\n}\n\n.success-icon svg {\n  width: 48px;\n  height: 48px;\n  stroke: white;\n}\n\n@keyframes scaleIn {\n  from {\n    transform: scale(0);\n    opacity: 0;\n  }\n  to {\n    transform: scale(1);\n    opacity: 1;\n  }\n}\n\n.success-screen h2 {\n  margin: 0 0 16px 0;\n  color: #333;\n  font-size: 32px;\n  font-weight: 700;\n}\n\n.success-screen > p {\n  color: #666;\n  font-size: 16px;\n  margin: 0 0 32px 0;\n  line-height: 1.6;\n}\n\n.whatsapp-button {\n  padding: 16px 48px;\n  background: linear-gradient(135deg, #25d366 0%, #128c7e 100%);\n  color: white;\n  border: none;\n  border-radius: 8px;\n  font-size: 16px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  margin-bottom: 16px;\n}\n\n.whatsapp-button:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 8px 20px rgba(37, 211, 102, 0.4);\n}\n\n.redirect-message {\n  color: #999;\n  font-size: 14px;\n  margin: 0;\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
